import {
  canAccessPmScheduleAttachment,
  canAccessPmTaskAttachment,
  type Actor,
} from 'domains-work-order-authorization';
import {
  getAttachmentAccess,
  type AttachmentAccess,
} from './getAttachmentAccess';
import {
  toPmScheduleResource,
  toPmTaskResource,
  type PmScheduleRecord,
  type PmTaskRecord,
} from './toPmResource';

interface PmAttachmentAccessRequest<TRecord> {
  actor: Actor;
  record: TRecord;
  isEnforced: boolean;
}

export const getPmTaskAttachmentAccess = ({
  actor,
  record,
  isEnforced,
}: PmAttachmentAccessRequest<PmTaskRecord>): AttachmentAccess =>
  getAttachmentAccess({
    actor,
    resource: toPmTaskResource(record),
    isEnforced,
    canAccess: canAccessPmTaskAttachment,
  });

export const getPmScheduleAttachmentAccess = ({
  actor,
  record,
  isEnforced,
}: PmAttachmentAccessRequest<PmScheduleRecord>): AttachmentAccess =>
  getAttachmentAccess({
    actor,
    resource: toPmScheduleResource(record),
    isEnforced,
    canAccess: canAccessPmScheduleAttachment,
  });
